import http from './http';
import notifier from '../_utils/notifier';

const contactsAPI = {
  getContacts(){
    return http.get('contacts/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке контактов произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  createContact(userId, payload){
    return http.post('contacts/',{ user:userId, ...payload })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При создании контакта произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  deleteContact(contactId){
    return http.delete('contacts/' + contactId + '/')
    .then(
      function(success) { return 'ok' },
      function(error) {
        notifier.alert(gettext('При удалении контакта произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  updateContact(contactId, accountValue){
    return http.patch('contacts/' + contactId + '/',{ account: accountValue })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При изменении контакта произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
}


export default contactsAPI;

